import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { FleetVehicle } from '@services/fleet-vehicle';
import { Organization } from '@services/organization';
import { SimulationTaskStatus } from './simulation-task-status.enum';
import { Simulation } from './simulation.class';
import { SimulationVehicle } from './simulation-vehicle.class';

export class SimulationTask extends BaseEntity {
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	simulationId: string;

	@Type(() => Simulation)
	simulation: Simulation;

	vehicleId: string;

	@Type(() => FleetVehicle)
	fleetVehicle: FleetVehicle;

	@Type(() => SimulationVehicle)
	taskVehicles: SimulationVehicle[];

	status: SimulationTaskStatus;
	errorMessage: string;

	electrificationYear?: number; // filled in FE

	get proposedTaskVehicle() {
		return this.taskVehicles.find(({ proposed }) => proposed);
	}

	get conversionListTableName() {
		return [this.fleetVehicle?.driverName, this.fleetVehicle?.driverSurname].filter(Boolean).join(' ') || '-';
	}

	get conversionListTableCurrentCar() {
		return [[this.fleetVehicle?.carModel?.brand, this.fleetVehicle?.carModel?.model].filter(Boolean).join(' ')];
	}

	get conversionListTableVoltaageSuggests() {
		const { brand, model } = this.proposedTaskVehicle?.carModel || {};
		return [[brand, model].filter(Boolean).join(' ')];
	}

	get conversionListTableEvSelection() {
		return [this.fleetVehicle?.selectedCarModel].filter(Boolean);
	}

	get conversionListTableBudget() {
		return this.fleetVehicle?.segment?.budgetRange || '';
	}

	get conversionListTableLeasing() {
		return this.fleetVehicle?.leasingPrice;
	}

	get subRows() {
		return [];
	}
}
